"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateStackedDiscount = void 0;
const calculateStackedDiscount = (discount1, discount2) => {
    // Convert percentages to decimals
    const decimalDiscount1 = discount1 / 100;
    const decimalDiscount2 = discount2 / 100;
    // Calculate the stacked discount
    const totalDiscountDecimal = 1 - (1 - decimalDiscount1) * (1 - decimalDiscount2);
    // Convert the result back to percentage and round to the nearest whole number
    const totalDiscountPercentage = Math.round(totalDiscountDecimal * 1000) / 10;
    return totalDiscountPercentage;
};
exports.calculateStackedDiscount = calculateStackedDiscount;
